import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {QuestionTypeFactoryService} from 'shared/questions/services/question-type-factory.service';
import {ModalAddQuestionModule} from './modal-add-question/modal-add-question.module';
import {ModalEditNodeModule} from './modal-edit-node/modal-edit-node.module';
import {TreeViewRepository} from './repositories/tree-view.repository';
import {NetworkService} from './services/network.service';
import {TreeViewService} from './services/tree-view.service';
import {TreeViewRoutingModule} from './tree-view-routing.module';
import {TreeViewComponent} from './tree-view.component';

@NgModule({
  imports: [
    CommonModule,
    TreeViewRoutingModule,
    ModalAddQuestionModule,
    ModalEditNodeModule,
  ],
  declarations: [
    TreeViewComponent,
  ],
  providers: [
    TreeViewRepository,
    TreeViewService,
    NetworkService,
    QuestionTypeFactoryService,
  ],
})
export class TreeViewModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/tree-view.module.ts